// MACHINERY V2 (Stroje) — Diely a materiál: the SHARED row contract (split out
// of partsRows.tsx at M2.16d step 3, near-cap rule).
//
// WHAT IT OWNS: the three things the DESKTOP row and the PHONE card must agree
// on — the column template, the prop shape, and how a part's number is read off
// the DTO. Nothing here renders.
//
// WHY IT IS SEPARATE AND WHY IT IS NOT JUST "PartPhoneCard IMPORTS FROM
// partsRows". partsRows.tsx stood at 252 of the project's 300-line cap and
// M2.16d has to add a `touch` member to `PartRowProps` (the below-1280 checkbox
// target). Splitting the phone card out of it leaves TWO renderers that both
// need the same props type and the same `partNumber` reader; pointing one at the
// other would make a presentational file the owner of a contract its sibling
// depends on, and `partsTabChrome.tsx` — which needs only `PC_GRID` — would
// still be importing a module full of JSX to get one string. A contract module
// that imports no renderer also cannot participate in an import cycle.
//
// No component, no JSX, no style: this file is deliberately `.ts`.
import { InstalledStockItem } from "../../../../inventory/models/models";
import { FleetMenuAction } from "../../fleet/FleetCardMenu";

/** Desktop column template — artboard 1009 (PC_GRID in the handoff). */
export const PC_GRID = "34px 42px minmax(200px, 1.2fr) minmax(160px, 1fr) 170px 190px";

export interface PartRowProps {
  item: InstalledStockItem;
  selected: boolean;
  onToggleSelect: () => void;
  actions: FleetMenuAction[];
  onMarketplace: () => void;
  menuLabel: string;
  selectLabel: string;
  /**
   * Below 1280 (`V2_BELOW_DESKTOP`) — raises the select checkbox to a legal
   * touch target. Defaults to today's desktop rendering when omitted, so no
   * declaration the >= 1280 element never had is emitted.
   *
   * IT IS READ ONCE PER VIEW, NOT PER ROW. PartsTabV2 evaluates the query and
   * passes the boolean down; a `useV2MediaQuery` call inside the row would open
   * one matchMedia listener per part, which that hook's header forbids by name.
   */
  touch?: boolean;
}

/** The part number as the row prints it. ONE reader, so the desktop row's
 *  `title` tooltip and the phone card's line can never disagree. */
export const partNumber = (item: InstalledStockItem): string =>
  item.stockItem?.product?.number || "";
